<template functional>
  <div :class="[
    'language-assistance small',
    data.class,
    data.staticClass
  ]">
    <h5>Language Assistance</h5>
    <ul class="list-unstyled d-flex flex-wrap mb-0">
      <li>
        <a href="https://www.hrsa.gov/about/language-assistance.html#german">Deutsch</a>
      </li>
      <li>
        <a href="https://www.hrsa.gov/about/language-assistance.html#english">English</a>
      </li>
      <li>
        <a href="https://www.hrsa.gov/about/language-assistance.html#spanish">Español</a>
      </li>
      <li>
        <a href="https://www.hrsa.gov/about/language-assistance.html#french">Français</a>
      </li>
      <li>
        <a href="https://www.hrsa.gov/about/language-assistance.html#italian">Italiano</a>
      </li>
      <li>
        <a href="https://www.hrsa.gov/about/language-assistance.html#hcreole">Kreyòl Ayisyen</a>
      </li>
      <li>
        <a href="https://www.hrsa.gov/about/language-assistance.html#polish">Polski</a>
      </li>
      <li>
        <a href="https://www.hrsa.gov/about/language-assistance.html#portuguese">Português</a>
      </li>
      <li>
        <a href="https://www.hrsa.gov/about/language-assistance.html#tagalog">Tagalog</a>
      </li>
      <li>
        <a href="https://www.hrsa.gov/about/language-assistance.html#vietnamese">Tiếng Việt</a>
      </li>
      <li>
        <a href="https://www.hrsa.gov/about/language-assistance.html#russian">Русский</a>
      </li>
      <li>
        <a href="https://www.hrsa.gov/about/language-assistance.html#arabic">العربية</a>
      </li>
      <li>
        <a href="https://www.hrsa.gov/about/language-assistance.html#farsi">فارسی</a>
      </li>
      <li>
        <a href="https://www.hrsa.gov/about/language-assistance.html#japanese">日本語</a>
      </li>
      <li>
        <a href="https://www.hrsa.gov/about/language-assistance.html#chinese">繁體中文</a>
      </li>
      <li>
        <a href="https://www.hrsa.gov/about/language-assistance.html#korean">한국어</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.language-assistance {
  a:not(:hover) { text-decoration: none; }

  li { width: 10em; }
}
</style>
